import { render, staticRenderFns } from "./SuccessSignup.vue?vue&type=template&id=4a7d495a&scoped=true&"
import script from "./SuccessSignup.vue?vue&type=script&lang=js&"
export * from "./SuccessSignup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a7d495a",
  null
  
)

export default component.exports